import { SelectableModel } from './general/selectable.model';

export class ListItemModel extends SelectableModel {
  id: number;
  value: string;
  // Defaults to true when the source omits the flag (e.g. region/role lists, or
  // account endpoints that don't yet return isActive) so nothing is hidden unless
  // the backend explicitly reports isActive=false.
  isActive = true;

  private _isSelected: boolean;
  constructor(id: number,
    value: string) {
    super();
    this.id = id;
    this.value = value;
    this._isSelected = false;
  }
  public static Parse(x): ListItemModel {
    const item = new ListItemModel(x['id'], x['value']);
    item.isActive = x['isActive'] ?? true;
    return item;
  }

  getSelected() {
    return this._isSelected;
  }
  toggleSelected() {
    this._isSelected = !this._isSelected;
  }
  setSelected(value: boolean) {
    this._isSelected = value;
  }

  public toString = (): string => {
    return `${this.value} (id: ${this.id})`;
  }
}
